import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FlexLayout from '../../../../components/common/FlexLayout';
import IconButton from '../../../../components/common/IconButton';
import { useActiveStateSelector } from '../../../../containers/customizer.duck';

const Goggle = ({
  options,
  goggleConfig,
  updatePartsConfig,
  removePartConfig,
  partsConfig
}) => {
  const [activeGoggle, setActiveGoggle] = useState(
    goggleConfig[Object.keys(goggleConfig)[0]]
  );
  useActiveStateSelector('goggle', options, partsConfig, setActiveGoggle);
  return (
    <FlexLayout>
      {options.map((option, i) => (
        <div className="goggle-item">
          <IconButton
            backgroundColor={activeGoggle ? '#000' : '#b7b7b7'}
            label={option.configData.label}
            icon={option.configData.icon}
            iconColor="#fff"
            onClick={() => {
              setActiveGoggle(!activeGoggle);
              if (activeGoggle) {
                removePartConfig();
              } else {
                updatePartsConfig(options[i]);
              }
            }}
          />
        </div>
      ))}
    </FlexLayout>
  );
};

Goggle.propTypes = {
  options: PropTypes.array,
  goggleConfig: PropTypes.object,
  updatePartsConfig: PropTypes.func,
  removePartConfig: PropTypes.func,
  initialSelectedCustomizationIndex: PropTypes.number
};

export default Goggle;
